<template>
  <div>
    <!-- MON IDENTITE NUMERIQUE -->
    <v-list-item :href="identiteUrl" target="_blank">
      <v-list-item-content>
        <v-list-item-title>
          <v-icon left>mdi-account</v-icon>Mon identité numérique
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-icon>
        <v-icon>mdi-open-in-new</v-icon>
      </v-list-item-icon>
    </v-list-item>
    <!-- ENT -->
    <v-list-item :href="entUrl" target="_blank">
      <v-list-item-content>
        <v-list-item-title>
          <v-icon left>mdi-apps</v-icon>ENT (Espace Numérique de Travail)
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-icon>
        <v-icon>mdi-open-in-new</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "BaseUserMenu",
  components: {},
  data() {
    return {
      // url vers MIN
      identiteUrl: process.env.VUE_APP_IDENTITE_URL,
      // url vers ENT
      entUrl: process.env.VUE_APP_ENT_URL
    };
  }
};
</script>
